export const getOauthRequestUrlPath = '/api/get_oauth_request_url'
export const getEnterprisePlanReportPath = '/api/get_enterprise_plan_report'
